import React from 'react';
import { ButtonUI, FormLabelUI, InputUI } from '../Interface';
import useParam from '../../context/ParamContext';

const CompanyContactAddFields = ({
  newContactState,
  resetContactAdd,
  onAdd,
  variant = 'standard',
  size,
  className = 'md:grid-cols-4',
}) => {
  const { params } = useParam();
  const { newContact, setNewContact } = newContactState;

  const handleChange = (field, value) => {
    setNewContact((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className={`col-span-full grid grid-cols-1 gap-x-4 gap-y-3 rounded bg-[#E7F3FD] p-2 ${className}`}>
      <div className="min-w-0">
        <InputUI
          fullWidth
          label={<FormLabelUI text="Kapcsolattartó" />}
          variant={variant}
          size={size}
          value={newContact.name}
          onChange={(e) => handleChange('name', e.target.value)}
        />
      </div>

      {params.SIMPLE_CONTACT_CREATE_SHOW_ROLE_FIELD === 'Y' && (
        <div className="min-w-0">
          <InputUI
            fullWidth
            label={<FormLabelUI text="Szerep" />}
            variant={variant}
            size={size}
            value={newContact.role}
            onChange={(e) => handleChange('role', e.target.value)}
          />
        </div>
      )}

      <div className="min-w-0">
        <InputUI
          fullWidth
          label={<FormLabelUI text="Telefonszám" />}
          variant={variant}
          size={size}
          value={newContact.phoneNumber}
          onChange={(e) => handleChange('phoneNumber', e.target.value)}
        />
      </div>

      <div className="min-w-0">
        <InputUI
          fullWidth
          label={<FormLabelUI text="E-mail cím" />}
          variant={variant}
          size={size}
          value={newContact.email}
          onChange={(e) => handleChange('email', e.target.value)}
        />
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <ButtonUI text="Mégse" className="bg-primary" size="sm" onClick={resetContactAdd} />
        <ButtonUI text="Hozzáadás" className="bg-success" size="sm" onClick={onAdd} />
      </div>
    </div>
  );
};

export default CompanyContactAddFields;
